export type SidebarTab = 'home' | 'agents' | 'search';

export function sidebarTabFromPath(pathname: string): SidebarTab {
  if (pathname.startsWith('/chat')) {
    return 'agents';
  }
  if (pathname.startsWith('/search')) {
    return 'search';
  }
  return 'home';
}

export function activeChatIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/chat\/([^/?]+)/);
  return match?.[1] ?? null;
}

export function activeSearchOpenIdFromPath(pathname: string): string | null {
  const pageMatch = pathname.match(/^\/search\/page\/([^/?]+)/);
  if (pageMatch?.[1]) {
    return pageMatch[1];
  }
  const databaseMatch = pathname.match(/^\/search\/database\/([^/?]+)/);
  return databaseMatch?.[1] ?? null;
}
